"use client";
import * as React from "react";
const SvgScheduleRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4M7.82 4h-.04a.57.57 0 0 0-.58.58v3.77c0 .28.14.55.4.69l3.31 2a.57.57 0 0 0 .79-.2.57.57 0 0 0-.2-.8L8.4 8.22V4.58A.57.57 0 0 0 7.82 4" }));
export {
  SvgScheduleRound as default
};
